import React from "react";
import { Box, Heading, Text, Button } from "@chakra-ui/react";

export default function TokenExpiredScreen({ onSignin }) {
    const handleSignIn = () => {
        if (typeof onSignin === "function") {
            onSignin();
        }
    };

    return (
        <Box
            minH="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bg="gray.50"
            px={4}
        >
            <Heading color="red.500" mb={4} fontSize="3xl">
                Session Expired
            </Heading>
            <Text fontSize="lg" color="gray.700" mb={6} textAlign="center">
                Your session has expired. Please sign in again to continue.
            </Text>
            <Button colorScheme="blue" size="lg" onClick={handleSignIn}>
                Sign In
            </Button>
        </Box>
    );
}
